module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/hlukovaMapa-85377bec6e8f99199d9ab54373b697f8.png";